// Product Model Carousel
class ProductModelCarousel {
  constructor(sectionId) {
    this.section = document.querySelector(`[data-section-id="${sectionId}"] .product-model-mobile-carousel`);
    if (!this.section) return;
    
    this.track = this.section.querySelector('.product-model-carousel-track');
    this.slides = this.section.querySelectorAll('.product-model-carousel-slide');
    this.indicators = this.section.querySelectorAll('.product-model-indicator');
    this.prevBtn = this.section.querySelector('.product-model-prev');
    this.nextBtn = this.section.querySelector('.product-model-next');
    
    this.currentIndex = 0;
    this.totalSlides = this.slides.length;
    this.autoPlayInterval = null;
    this.isDragging = false;
    this.startX = 0;
    this.currentX = 0;
    this.dragDistance = 0;
    
    this.init();
  }
  
  init() {
    if (this.totalSlides <= 1 || window.innerWidth > 767) return;
    
    this.updateCarousel();
    this.setupEventListeners();
    
    // Check if autoplay is enabled
    const sectionContainer = this.section.closest('[data-section-id]');
    if (sectionContainer) {
      this.startAutoPlay();
    }
  }
  
  setupEventListeners() {
    // Indicators
    this.indicators.forEach(indicator => {
      indicator.addEventListener('click', (e) => {
        const index = parseInt(e.target.dataset.index);
        this.goToSlide(index);
        this.resetAutoPlay();
      });
    });
    
    // Navigation buttons
    if (this.prevBtn) {
      this.prevBtn.addEventListener('click', () => {
        this.prevSlide();
        this.resetAutoPlay();
      });
    }
    
    if (this.nextBtn) {
      this.nextBtn.addEventListener('click', () => {
        this.nextSlide();
        this.resetAutoPlay();
      });
    }
    
    // Touch events
    this.track.addEventListener('touchstart', this.handleTouchStart.bind(this), { passive: true });
    this.track.addEventListener('touchmove', this.handleTouchMove.bind(this), { passive: true });
    this.track.addEventListener('touchend', this.handleTouchEnd.bind(this));
    
    // Pause on hover
    this.section.addEventListener('mouseenter', () => this.pauseAutoPlay());
    this.section.addEventListener('mouseleave', () => this.startAutoPlay());
    
    // Handle resize
    window.addEventListener('resize', () => this.handleResize());
  }
  
  handleTouchStart(e) {
    this.isDragging = true;
    this.startX = e.touches[0].clientX;
    this.currentX = this.startX;
    this.dragDistance = 0;
    this.pauseAutoPlay();
  }
  
  handleTouchMove(e) {
    if (!this.isDragging) return;
    
    this.currentX = e.touches[0].clientX;
    this.dragDistance = this.startX - this.currentX;
    this.updateDragPosition();
  }
  
  handleTouchEnd() {
    if (!this.isDragging) return;
    
    this.isDragging = false;
    this.handleDragEnd();
    this.resetAutoPlay();
  }
  
  updateDragPosition() {
    const slideWidth = this.track.offsetWidth;
    const dragOffset = (this.dragDistance / slideWidth) * 100;
    const baseOffset = -this.currentIndex * 100;
    const totalOffset = baseOffset + dragOffset;
    
    this.track.style.transform = `translateX(${totalOffset}%)`;
  }
  
  handleDragEnd() {
    const slideWidth = this.track.offsetWidth;
    const threshold = slideWidth * 0.2;
    
    if (Math.abs(this.dragDistance) > threshold) {
      if (this.dragDistance > 0) {
        this.nextSlide();
      } else {
        this.prevSlide();
      }
    } else {
      this.updateCarousel();
    }
  }
  
  goToSlide(index) {
    if (index < 0 || index >= this.totalSlides) return;
    
    this.currentIndex = index;
    this.updateCarousel();
  }
  
  nextSlide() {
    this.currentIndex = (this.currentIndex + 1) % this.totalSlides;
    this.updateCarousel();
  }
  
  prevSlide() {
    this.currentIndex = (this.currentIndex - 1 + this.totalSlides) % this.totalSlides;
    this.updateCarousel();
  }
  
  updateCarousel() {
    // Update slide position
    const offset = -this.currentIndex * 100;
    this.track.style.transform = `translateX(${offset}%)`;
    
    // Update indicators
    this.indicators.forEach((indicator, index) => {
      if (index === this.currentIndex) {
        indicator.classList.add('active');
      } else {
        indicator.classList.remove('active');
      }
    });
  }
  
  startAutoPlay() {
    if (window.innerWidth > 767) return;
    
    this.pauseAutoPlay();
    this.autoPlayInterval = setInterval(() => {
      this.nextSlide();
    }, 3000);
  }
  
  pauseAutoPlay() {
    if (this.autoPlayInterval) {
      clearInterval(this.autoPlayInterval);
      this.autoPlayInterval = null;
    }
  }
  
  resetAutoPlay() {
    this.startAutoPlay();
  }
  
  handleResize() {
    if (window.innerWidth > 767) {
      this.pauseAutoPlay();
    } else {
      this.updateCarousel();
      this.startAutoPlay();
    }
  }
}

// Initialize all carousels on the page
document.addEventListener('DOMContentLoaded', () => {
  const sections = document.querySelectorAll('[data-section-id]');
  
  sections.forEach(section => {
    const sectionId = section.dataset.sectionId;
    const carousel = section.querySelector('.product-model-mobile-carousel');
    
    if (carousel) {
      new ProductModelCarousel(sectionId);
    }
  });
});